import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import SweetAlert from "react-bootstrap-sweetalert";
import { RiUserSearchLine } from "react-icons/ri";

import { makeStyles } from "@material-ui/core/styles";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";

import sty from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import style from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

const useStyles = makeStyles(sty);
const useAlertStyles = makeStyles(style);

export default function SearchWhatsApp() {
    const classes = useStyles();
    const alertClasses = useAlertStyles();
    const history = useHistory();

    const [mobile, setMobile] = useState("");
    const [mobileErr, setMobileErr] = useState("");
    const [countryCode, setCountryCode] = useState("in");
    const [countryName, setCountryName] = useState("India");
    const [dialCode, setDialCode] = useState("91");

    // alert state and type ('success' or 'error')
    const [alert, setAlert] = useState(false);
    const [alertMsg, setAlertMsg] = useState("");
    const [alertType, setAlertType] = useState("success");

    const mystyle = {
        paddingLeft: 12,
        flex: 1,
        marginLeft: 15,
    };

    const handlePhoneChange = (value, countryData) => {
        setMobile(value);
        setMobileErr("");
        if (countryData) {
            setCountryCode(countryData.countryCode);
            setDialCode(countryData.dialCode);
            setCountryName(countryData.name);
        }
    };

    const SubmitSearchClient = () => {
        if (!mobile) {
            setMobileErr("Please enter a mobile number.");
            return;
        }

        const numericMobile = mobile.replace(/\D/g, "");

        let nationalNumber = numericMobile;
        if (numericMobile.startsWith(dialCode)) {
            nationalNumber = numericMobile.slice(dialCode.length);
        }

        const { min = 5, max = 15 } = countryPhoneLengths[countryCode.toLowerCase()] || {};

        if (nationalNumber.length < min || nationalNumber.length > max) {
            setAlertMsg(`Please enter a valid mobile number (${min}-${max} digits) for ${countryName}.`);
            setAlertType("error");
            setAlert(true);
            return;
        }

        const message = `Hi there! 👋
I'm Indian Bangles Manufacture & Wholesale.
Could you please provide more details? Thanks!

More info: https://indianbangles.in
Please get back to me. Thanks!`;

        const encodedMessage = encodeURIComponent(message);

        const whatsAppLink = `https://api.whatsapp.com/send?phone=${mobile}&text=${encodedMessage}&app_absent=0`;

        // Open WhatsApp link in new tab
        window.open(whatsAppLink, "_blank");

        setAlertMsg(`Searching WhatsApp for: +${mobile} (${countryName})`);
        setAlertType("success");
        setAlert(true);
    };

    const hideAlert = () => {
        setAlert(false);
        if (alertType === "success") {
            window.location.reload();
        }
    };

    return (
        <div>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={8}>
                    <Card>
                        <CardHeader color="rose" icon>
                            <CardIcon color="rose">
                                <RiUserSearchLine />
                            </CardIcon>
                            <h3 className={classes.cardIconTitle}>
                                <small>Search Client WhatsApp</small>
                            </h3>
                        </CardHeader>
                        <CardBody>
                            <GridContainer justify="center" alignItems="center">
                                <form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        SubmitSearchClient();
                                    }}
                                >
                                    <PhoneInput
                                        style={mystyle}
                                        country={countryCode}
                                        value={mobile}
                                        onChange={handlePhoneChange}
                                        enableAreaCodes={true}
                                        disableCountryGuess={true}
                                        countryCodeEditable={false}
                                        inputStyle={{ width: "100%" }}
                                        required
                                    />
                                    <br />
                                    <div className={classes.center}>
                                        <span style={{ color: "red" }}>{mobileErr}</span>
                                    </div>
                                    <br />
                                    <div className={classes.center}>
                                        <Button
                                            color="rose"
                                            type="submit"
                                            className={classes.updateProfileButton}
                                        >
                                            Search Client WhatsApp
                                        </Button>
                                    </div>
                                </form>
                            </GridContainer>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>

            {alert && (
                <SweetAlert
                    title={alertType === "error" ? "Error" : "Success"}
                    success={alertType === "success"}
                    error={alertType === "error"}
                    onConfirm={hideAlert}
                    confirmBtnCssClass={
                        alertType === "success"
                            ? alertClasses.button + " " + alertClasses.success
                            : alertClasses.button + " " + alertClasses.danger
                    }
                >
                    {alertMsg}
                </SweetAlert>
            )}
        </div>
    );
}

const countryPhoneLengths = {
    in: { min: 10, max: 10 },
    us: { min: 10, max: 10 },
    ae: { min: 9, max: 9 },
    pk: { min: 10, max: 10 },
    bd: { min: 10, max: 10 },
    gb: { min: 10, max: 10 },
    ca: { min: 10, max: 10 },
    au: { min: 9, max: 9 },
    sa: { min: 9, max: 9 },
    ng: { min: 10, max: 10 },
    ke: { min: 9, max: 9 },
    za: { min: 9, max: 10 },
    de: { min: 8, max: 11 },
    fr: { min: 9, max: 10 },
    it: { min: 9, max: 10 },
    es: { min: 9, max: 9 },
    cn: { min: 11, max: 11 },
};
